import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import React from 'react';
import styled from '@xstyled/styled-components';
import { MathEnabledTextComponent, getColor, getSize } from '@lib/common';
import { useDescriptionCollapse } from '../../../shared/hooks/use-description-collapse.hook';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: ", " ", ";\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'), getSize('padding20'), getColor('fillBgSub'), getColor('shapeBorder'), getSize('radiusSm'), getSize('padding8'));
var StyledTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  color: ", ";\n  letter-spacing: 0.05em;\n  user-select: none;\n"])), getSize('typo14'), getColor('contentMinimum'));
var StyledContent = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: 1.6;\n  color: ", ";\n\n  ", "\n\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), getSize('typo15'), getColor('contentHeading'), function (_ref) {
  var $reserveToggleSpace = _ref.$reserveToggleSpace;
  return $reserveToggleSpace && "\n      p:last-child::after {\n        content: '';\n        display: inline-block;\n        width: 96px;\n        height: 1px;\n      }\n    ";
});
var StyledEmptyText = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-style: italic;\n  color: ", ";\n  line-height: 1.6;\n"])), getSize('typo15'), getColor('contentMinimum'));
var StyledDescriptionContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  max-height: ", ";\n  transition: max-height 350ms ease-in-out;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n"])), function (_ref2) {
  var $maxHeight = _ref2.$maxHeight;
  return $maxHeight ? "".concat($maxHeight, "px") : 'none';
});
var StyledExpandCollapseButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  padding: 0 0 0 ", ";\n  background: linear-gradient(\n    to right,\n    transparent,\n    ", " ", "\n  );\n  border: none;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), getSize('padding24'), getColor('fillBgSub'), getSize('padding24'), getColor('fillIntActive'), getSize('typo14'));
export var isContentEmpty = function isContentEmpty(content) {
  if (!content) return true;
  var trimmed = content.trim();
  if (!trimmed) return true;
  if (/<img[^>]+>/gi.test(trimmed)) return false;
  var withoutHTML = trimmed.replace(/\s/g, '').replace(/(<([^>]+)>)/gi, '');
  return !withoutHTML || withoutHTML.length === 0;
};
export var QuestionDescriptionComponent = function QuestionDescriptionComponent(_ref3) {
  var description = _ref3.description,
      title = _ref3.title,
      emptyText = _ref3.emptyText,
      label = _ref3.label,
      className = _ref3.className,
      content = _ref3.content,
      children = _ref3.children,
      _ref3$isShowingExtend = _ref3.isShowingExtendOrCollapse,
      isShowingExtendOrCollapse = _ref3$isShowingExtend === void 0 ? true : _ref3$isShowingExtend;
  var displayTitle = title || (label === null || label === void 0 ? void 0 : label.questionDescriptionTitle);
  var displayEmptyText = emptyText || (label === null || label === void 0 ? void 0 : label.noQuestionDescription);
  var isEmpty = isContentEmpty(description);

  var _useDescriptionCollap = useDescriptionCollapse({
    description: description,
    enabled: isShowingExtendOrCollapse && content === undefined
  }),
      contentRef = _useDescriptionCollap.contentRef,
      collapsedHeight = _useDescriptionCollap.collapsedHeight,
      contentHeight = _useDescriptionCollap.contentHeight,
      isCollapsible = _useDescriptionCollap.isCollapsible,
      isExpanded = _useDescriptionCollap.isExpanded,
      isOverflowing = _useDescriptionCollap.isOverflowing,
      toggleExpanded = _useDescriptionCollap.toggleExpanded;

  var showCollapseControl = isCollapsible && isOverflowing;
  var expandLabel = (label === null || label === void 0 ? void 0 : label.readMore) || (label === null || label === void 0 ? void 0 : label.seeMore) || 'Show more';
  var collapseLabel = (label === null || label === void 0 ? void 0 : label.readLess) || (label === null || label === void 0 ? void 0 : label.seeLess) || 'Show less';
  var maxHeight = showCollapseControl ? isExpanded ? contentHeight : collapsedHeight : undefined;
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    className: className,
    children: [/*#__PURE__*/_jsx(StyledTitle, {
      children: displayTitle
    }), isEmpty ? /*#__PURE__*/_jsx(StyledEmptyText, {
      children: displayEmptyText
    }) : content !== undefined ? content : /*#__PURE__*/_jsxs(StyledDescriptionContainer, {
      $maxHeight: maxHeight,
      children: [/*#__PURE__*/_jsx(StyledContent, {
        ref: contentRef,
        value: description,
        $reserveToggleSpace: showCollapseControl && isExpanded
      }), showCollapseControl && /*#__PURE__*/_jsx(StyledExpandCollapseButton, {
        type: "button",
        "aria-expanded": isExpanded,
        onClick: function onClick(event) {
          event.stopPropagation();
          toggleExpanded();
        },
        children: isExpanded ? collapseLabel : "\u2026 ".concat(expandLabel)
      })]
    }), children]
  });
};